import { z } from 'zod';
import { ROLES } from './permissions.js';
const roleSchema = z.enum(ROLES);
const visitRouting = z.enum(['sharer', 'manager']);
const optionalText = (max) => z.string().trim().max(max).optional();
export const createAgencySchema = z.object({
    name: z.string().trim().min(2).max(80),
    city: z.string().trim().min(2).max(60).default('Pune'),
    branchName: z.string().trim().min(1).max(60),
    branchArea: optionalText(80),
    /** The broker's own name: on the memo, the proof and every list that names the agent. */
    ownerName: z.string().trim().min(2).max(80),
    /** How clients and owners reach the agency. Required, so no public page is a dead end. */
    phone: z.string().trim().min(10).max(20),
    whatsapp: z.string().trim().min(10).max(20),
});
export const agencyContactSchema = z.object({
    phone: z.string().trim().min(10).max(20),
    whatsapp: z.string().trim().min(10).max(20),
});
export const createBranchSchema = z.object({
    name: z.string().trim().min(1).max(60),
    area: optionalText(80),
    address: optionalText(300),
    phone: optionalText(20),
    visitRouting: visitRouting.optional(),
    /** Suggested visit times shown on public pages, at most three. */
    visitSlots: z.array(z.string().trim().min(1).max(60)).max(3).optional(),
    visitResponse: z.enum(['within_an_hour', 'today', 'within_a_day']).optional(),
});
export const updateBranchSchema = createBranchSchema
    .partial()
    .refine((value) => Object.keys(value).length > 0, 'Provide at least one field');
export const changeRoleSchema = z.object({ role: roleSchema });
export const moveMemberSchema = z.object({
    branchId: z.string().uuid(),
    /** Move the member's open records to the new branch too. Without it they stay put. */
    moveRecords: z.boolean().default(false),
});
export const createInviteSchema = z
    .object({
    phone: z.string().trim().min(1).max(20),
    role: roleSchema,
    branchId: z.string().uuid(),
    /** Queue the invite as a WhatsApp message. Needs the consent attestation (R17). */
    notifyOnWhatsapp: z.boolean().default(false),
    /** The inviter attests the invitee agreed to be contacted on WhatsApp. */
    whatsappConsentAttested: z.boolean().default(false),
})
    .refine((value) => !value.notifyOnWhatsapp || value.whatsappConsentAttested, {
    message: 'Confirm that the person agreed to be contacted on WhatsApp',
    path: ['whatsappConsentAttested'],
});
export const acceptInviteSchema = z.object({ token: z.string().trim().min(20).max(200) });
export const RECORD_TYPES = ['properties', 'visits', 'deals', 'renewals'];
/**
 * Moves a member's open records (master 8.10, R14): to one member, or spread evenly over the
 * active agents and managers of a branch.
 */
export const reassignRecordsSchema = z
    .object({
    types: z.array(z.enum(RECORD_TYPES)).min(1),
    toMemberId: z.string().uuid().optional(),
    toBranchId: z.string().uuid().optional(),
})
    .refine((value) => (value.toMemberId === undefined) !== (value.toBranchId === undefined), {
    message: 'Choose one member, or one branch to spread the records over',
});
//# sourceMappingURL=identity.js.map